module.exports = __webpack_public_path__ + "media/images/emblems/Kippel-coat_of_arms-5fbfdbac16a780fcaf2a774ae8ff8370.svg";